import BasicLoadable from "../../../Loadable/BasicLoadable";

export const LoadableLocationModals = BasicLoadable({
  loader: () => import("./LocationModals"),
  loading: null,
});
